import { type MaybeRefOrGetter, ref, toValue } from 'vue'

import type { ContentCard } from '../PersonalizedFeed.utils'

export function useActiveTabIndex(
  contentCards: MaybeRefOrGetter<ContentCard[]>,
) {
  const activeTabIndex = ref(0)

  let onTabChangeCallback: () => void | undefined
  function onTabChange(callback: () => void) {
    onTabChangeCallback = callback
  }
  function setActiveTabIndex(index: number) {
    onTabChangeCallback?.()
    if (index === activeTabIndex.value) return

    activeTabIndex.value = index
  }

  function goToPreviousTab() {
    const newIndex = Math.max(activeTabIndex.value - 1, 0)
    setActiveTabIndex(newIndex)
  }

  function goToNextTab() {
    const newIndex = Math.min(
      activeTabIndex.value + 1,
      toValue(contentCards).length - 1,
    )
    setActiveTabIndex(newIndex)
  }

  return {
    activeTabIndex,
    setActiveTabIndex,
    goToPreviousTab,
    goToNextTab,
    onTabChange,
  }
}
